// 订单信息
// 订单列表
export const creditorderlist = "/zulin/pc/user/credit/order/list"
// 结算详单
export const orderdetail = "/zulin/pc/user/credit/order/detail?orderId="

export const orderDetailByBizNo = "/zulin/pc/user/credit/order/detail?bizNo="

export const exportAllOrder = "/zulin/pc/export/excel/all/orders"

export const confirmHxOrderCheck = "/zulin/pc/order/settle/mortgage"

// 订单审核
export const creditorderauth = "/zulin/pc/user/credit/order/auth"

export const finalscoresubmit = "/zulin/pc/risk/scorecard/submit"

export const queryfinalscore = "/zulin//pc/risk/scorecard/finalScore"

// 用户认证列表
export const userauthlist = "/zulin/pc/user/auth/authList"
// 用户认证详情
export const userauthdetail = "/zulin/pc/user/credit/order/detail?bizNo="

// 结算管理
export const settlelist = "/zulin/pc/merchant/settle/list"
// 结算状态修改
export const updateSettleStatus = "/zulin/pc/merchant/settle/offPay"
// 修改结算订单
export const updateSettleOrder = "/zulin/pc/order/settle/detail/modify"
// 结算管理
export const settledetaillist = "/zulin/pc/order/settle/detail/list"
// 结算导出
export const settledetaillistExport = "/zulin/pc/export/excel/settle/detail"
// 结算打款
export const settlePayoff = "/zulin/pc/order/settle/payoff"
// 结算收款账户查询
export const settleReceiverAccountList = "/zulin/pc/order/settle/receiver/account"
// 结算详单
export const settledetails = "/zulin/pc/merchant/settle/details?settleNo="
// 付款账号配置
export const settleAccountConfig = "/zulin/pc/credit/conf/payment/account"
// 直接付款
export const settleDirectPay = "/zulin/pc/order/settle/alipay/direct"
// 支付流水
export const paymentlist = "/zulin/pc/user/payment/list"
// 还款账单
export const loanbilllist = "/zulin/pc/loan/bill/list"
// 和喜还款账单
export const loanbilllistHx = "/zulin/pc/loan/bill/hx/list"
// 还款订单明细
export const repaymentbillorder = "/zulin/pc/user/payment/repay/detail"
// 结算单列表
export const settleOrderList = "/zulin/pc/order/settle/list"
// 人工打款
export const settleTransfer = "/zulin/pc/order/settle/transfer"
// 结算单详情
export const settleOrderDetail = "/zulin/pc/order/settle/detail?settleNo="
// 合同管理
export const contractlist = "/zulin/pc/user/contract/list"

// 获取阿里云地址
export const filegetUrl = "/zulin/pc/file/getUrl"

// 上传手机型号图片识别
export const modelUploadRecognize = "/zulin/pc/subject/model/upload"

// 活体审核
export const padauthList = "/zulin/pc/user/pad/authList"
// 活体审核
export const padauth = "/zulin/pc/user/pad/auth"
// 活体审核详情
export const paddetail = "/zulin/pc/user/pad/detail?id="

// 退款管理
export const refundlist = "/zulin/pc/refund/list"
// 退款详单
export const refundorderdetail = "/zulin/pc/user/credit/order/detail?bizNo="
// 代扣
export const billautoCollect = "/zulin/pc/loan/bill/autoCollect"

export const materiallist = "/zulin/pc/user/credit/order/material/list"

export const getGpsWarnList = "/zulin/pc/user/credit/order/gps/list"

export const savematerial = "/zulin/pc/user/credit/order/material/save"

export const deleteMaterial = "/zulin/pc/user/credit/order/material/delete"

export const getCommissionListByMerchant = "/zulin/pc/user/merchant/commission/list?merchantId="

export const deleteMerchantCommission = "/zulin/pc/user/merchant/commission/remove"

export const addMerchantCommission = "/zulin/pc/user/merchant/commission/create"

export const updateMerchantCommission = "/zulin/pc/user/merchant/commission/modify"

export const queryUserLastCommission = "/zulin/pc/commission/user/lastConf?userId="

export const getMarkupListByMerchant = "/zulin/pc/user/merchant/markup/list?merchantId="

export const addMerchantMarkup = "/zulin/pc/user/merchant/markup/create"

export const updateMerchantMarkup = "/zulin/pc/user/merchant/markup/modify"

export const deleteMerchantMarkup = "/zulin/pc/user/merchant/markup/remove"

export const getMarkupModelList = "/zulin/pc/subject/model/validList?merchantId="

export const proveBillGetUrl = "/zulin/pc/user/payment/prove/pdf"

export const updateProveStatus = "/zulin/pc/user/credit/order/prove/update"

export const updateUserRiskLevel = "/zulin/pc/user/auth/updateRisk"

export const finaljudgeSubjectModelList = "/zulin/pc/subject/model/business/list"

export const merchantInfoUpdate = "/zulin/pc/user/merchant/update"

export const finaljudgeRiskList = "/zulin/pc/risk/log/list"

export const addMerchantInfo = "/zulin/pc/user/merchant/create"

export const addHallInfo = "/zulin/pc/user/shop/add"

export const hallInfoUpdate = "/zulin/pc/user/shop/update"

export const updateHallCity = "/zulin/pc/user/merchant/update"

export const modifySerialNumber = "/zulin/pc/user/credit/order/modifySerialNumber"

export const createAuditCallOrder = "/zulin/pc/user/credit/order/video"

export const getPhoneContactList = "/zulin/pc/user/credit/order/phoneBook/list"

export const queryPhoneContactStatus = "/zulin/pc/user/phone/risk/detect"

export const getProveRecordList = "/zulin/pc/user/payment/prove/income"

export const addMaterialRemark = "/zulin/pc/user/credit/order/material/addRemark"

export const getUserOperateRecordList = "/zulin/pc/user/auth/telCheck/log"

export const queryUserOtherPhoneList = "/zulin/pc/user/phone/list"

export const saveUserOtherPhone = "/zulin/pc/user/phone/save"

export const updateUserOtherPhone = "/zulin/pc/user/phone/update"

export const deleteUserOtherPhone = "/zulin/pc/user/phone/delete"

export const getUserSmsList = "/zulin/pc/user/credit/order/userSms/list"

export const getUserSmsRemarkTypeList = "/zulin/pc/user/credit/order/userSms/markTypeNames"

export const getUserPhoneCallList = "/zulin/pc/user/credit/order/callLog/list"

export const getUserAppList = "/zulin/pc/user/credit/order/userApp/list"

export const rollBackToAuthStep = "/zulin/pc/user/auth/rollback"

export const queryOtherPhoneRisk = "/zulin/pc/user/phone/risk/detect"

export const saveUserRemark = "/zulin/pc/user/register/remark"

export const getUserRemarkHistory = "/zulin/pc/user/remarkLog/list"

export const submitNeedContracct = "/zulin/pc/user/credit/order/needContract"

export const orderPreAuth = "/zulin/pc/user/credit/order/preAuth"

export const orderPreSelectpackage = "/zulin/pc/user/credit/order/admImprove"

export const copyPreSelectpackage = "/zulin/pc/user/credit/order/copy"

export const modifyProductOrder = "/zulin/pc/user/credit/order/resetPrice"

export const orderPreSearchSeller = "/zulin/pc/user/seller/search"

export const getXdMerchantList = "/zulin/pc/user/merchant/xd/list"

export const updateDeviceRegion = "/zulin/pc/user/credit/order/region"

export const getSelectPackageBrandList = "/zulin/api/common/brands/preTest"

export const getSelectPackageLoanTypeList = "/zulin/api/common/loan/rate"

export const getSelectPackageProductInfo = "/zulin/pc/credit/conf/products"

export const calculateSelectPackage = "/zulin/api/common/fee/preTest"

export const updateOrderStatus = "/zulin/pc/user/credit/order/status"

export const addRepaymentCollection = "/zulin/pc/loan/collection/save"

export const getAuthRemarkSuggest = "/zulin/pc/conf/authRemark/suggest/list"

export const saveAuthRemarkSuggest = "/zulin/pc/conf/authRemark/suggest/save"

export const getRepaymentCollectionList = "/zulin/pc/loan/collection/list"

export const createRepaymentBill = "/zulin/pc/loan/bill/create"

export const createLawBill = "/zulin/pc/loan/bill/law/init"

export const updateLawBill = "/zulin/pc/loan/bill/law/save"

export const minusRepaymentBill = "/zulin/pc/loan/bill/offline"

export const minusQrCodePay = "/zulin/pc/loan/bill/payQrCode"

export const getSameIpOrDeviceList = "/zulin/pc/user/sameDevice/list"

export const deleteContract = "/zulin/pc/user/credit/order/contract/delete"

export const addHallRemark = "/zulin/pc/user/shop/add/remark"

export const deleteCollectionRecord = "/zulin/pc/loan/collection/remove"

export const getOrderOperationRecord = "/zulin/pc/user/credit/order/editLog/list"

export const getRepaymentAnalyzeList = "/zulin/pc/user/report/repay/list"

export const getShopOverdueAnalyzeList = "/zulin/pc/user/report/shop/overdue"

export const getShopDueOrderList = "/zulin/pc/user/report/shop/due/orderList"

export const getShopOverdueOrderList = "/zulin/pc/user/report/shop/overdue/orderList"

export const getShopOverdueBillList = "/zulin/pc/user/report/shop/overdue/billList"

export const getShopOverdueBlackUserOrderList = "/zulin/pc/user/report/shop/blackUser/orderList"

export const getDeviceOverdueAnalyzeList = "/zulin/pc/user/report/device/overdue"

export const getDeviceDueOrderList = "/zulin/pc/user/report/device/due/orderList"

export const getDeviceOverdueOrderList = "/zulin/pc/user/report/device/overdue/orderList"

export const getDeviceOverdueBlackUserOrderList = "/zulin/pc/user/report/device/blackUser/orderList"

export const getPeriodOverdueAnalyzeList = "/zulin/pc/user/report/period/overdue"

export const getPeriodDueOrderList = "/zulin/pc/user/report/period/due/orderList"

export const getPeriodOverdueOrderList = "/zulin/pc/user/report/period/overdue/orderList"

export const getPeriodOverdueBlackUserOrderList = "/zulin/pc/user/report/period/blackUser/orderList"

export const getRegionOverdueAnalyzeList = "/zulin/pc/user/report/region/overdue"

export const getRegionDueOrderList = "/zulin/pc/user/report/region/due/orderList"

export const getRegionOverdueOrderList = "/zulin/pc/user/report/region/overdue/orderList"

export const getRegionOverdueBlackUserOrderList = "/zulin/pc/user/report/region/blackUser/orderList"

export const getHxOverdueAnalyze = "/zulin/pc/user/report/hexi/overdue"

export const getRepaymentDayAnalyzeList = "/zulin/pc/user/report/repay/dayList"

export const getProveAnalyzeInfo = "/zulin/pc/user/payment/prove/info"

export const getProveTranscatList = "/zulin/pc/user/payment/prove/tranParty"

export const getProveBankcardList = "/zulin/pc/user/payment/prove/tran/bank/list"

export const getProveBillDetailList = "/zulin/pc/user/payment/prove/tran/list"

export const getProveBillDetailSumary = "/zulin/pc/user/payment/prove/tran/summary"

export const getProveBillNearbyList = "/zulin/pc/user/payment/prove/tran/limitList"

export const getProveBigSalaryList = "/zulin/pc/user/payment/prove/tran/bigAmt/list"

export const getEarlyPayDiscount = "/zulin/api/common/fee/settle/discount"

export const getProvecharData = "/zulin/pc/user/payment/prove/chart/data"

export const getProveMarkTypeNames = "/zulin/pc/user/payment/prove/tran/markTypeNames"

export const getProveWarnList = "/zulin/pc/user/payment/prove/tran/duplicate/list"

export const getUnuseAnalyzeData = "/zulin/pc/user/payment/prove/unused/data"

export const getPhoneCallAnalyze = "/zulin/pc/user/phone/callBook/list"

export const getPhoneCallHoursAnalyze = "/zulin/pc/user/phone/callBook/hourList"

export const getPhoneCallDetail = "/zulin/pc/user/phone/callBook/details"

export const getPhoneModelHistory = "/zulin/pc/"

export const getPhoneRepeatList = "/zulin/pc/risk/phone/warns"

export const getMdmDeviceList = "/zulin/pc/mdm/device/list"

export const getMdmWarnList = "/zulin/pc/mdm/device/warn/list"

export const confirmMdmWarn = "/zulin/pc/mdm/device/warn/confirm"

export const getMdmDeviceDetail = "/zulin/pc/mdm/device/info"

export const getMdmDeviceStateList = "/zulin/pc/mdm/device/state/list"

export const getMdmDevicePackageList = "/zulin/pc/mdm/device/app/list"

export const getUserLastBizInfo = "/zulin/pc/user/credit/order/detail/userId"

export const getWxMerchantList = "/zulin/pc/credit/conf/wechat/merchant"

export const updateWxMerchant = "/zulin/pc/user/credit/order/modifyWxMerchant"

export const updateInvestor = "/zulin/pc/user/credit/order/investorType"

export const getTempBillList = "/zulin/pc/loan/tempBill/list"

export const addTempBill = "/zulin/pc/loan/tempBill/save"

export const updateTempBill = "/zulin/pc/loan/tempBill/update"

export const deleteTempBill = "/zulin/pc/loan/tempBill/delete"

export const confirmHxBillCheck = "/zulin/pc/loan/bill/hx/addCheck"

export const addPhoneBookRemark = "/zulin/pc/user/credit/order/phoneBook/addRemark"

export const editPhoneBook = "/zulin/pc/user/credit/order/phoneBook/modify"

export const queryUserRisk = "/zulin/pc/user/register/risk/estimate"

export const queryMerchantRisk = "/zulin/pc/user/merchant/risk/estimate"

export const queryHexiModelSimilar = "/zulin/pc/subject/hexi/model/similar"

export const calHexiPrinciple = "/zulin/pc/user/credit/order/rePrinciple"

export const getOrderIdBySerialNo = "/zulin/pc/user/credit/order/serialNumber/query?serialNumber="

export const confirmSettlePay = "/zulin/pc/order/settle/goodFee"

export const updateSettlePayAccount = "/zulin/pc/order/settle/modify/account"

export const addPhoneRecordRemark = "/zulin/pc/user/credit/order/callLog/addWxTag"

export const addElementTag = "/zulin/pc/element/tag/save"

export const updateOrderEmail = "/zulin/pc/user/credit/order/email/update"

export const queryExtraPayList = "/zulin/pc/user/extraPay/pageList"

export const addExtraPay = "/zulin/pc/user/extraPay/save"

export const getExtraQrCode = "/zulin/pc/loan/extra/payQrCode"

export const deleteExtraPay = "/zulin/pc/user/extraPay/delete"

export const queryExtraPayDetail = "/zulin/pc/user/extraPay/detail?id="

export const queryOrderExtraPayList = "/zulin/pc/user/extraPay/queryList?bizNo="

export const getCheckHxBillList = "/zulin/pc/check/hexi/pageList"

export const getCheckHxTotal = "/zulin/pc/check/hexi/data"

export const exportHxBill = "/zulin/pc/export/excel/hexi/order"

export const importHxBill = "/zulin/pc/import/excel/hexi/mortgage/upload"

export const syncHxBill = "/zulin/pc/loan/bill/hx/sync"

export const syncJiangenBill = "/zulin/pc/loan/bill/jiangen/sync"

export const queryAlipayAccountSettle = "/zulin/pc/order/settle/alipay/account"

export const queryWechatPushList = "/zulin/pc/wechat/work/pushList?orderStatus="

export const sendWechatPushMsg = "/zulin/pc/wechat/work/pushMsg"

export const queryWechatAllStatus = "/zulin/pc/wechat/work/allStatus"

export const distributeAudit = "/zulin/pc/user/credit/order/auth/distribute"

export const getDistributeAudit = "/zulin/pc/user/manager/list/authLevel"

export const getRecycleCommissionListByMerchant = "/zulin/pc/user/merchant/recycle/commission/list?merchantId="

export const deleteRecycleMerchantCommission = "/zulin/pc/user/merchant/recycle/commission/remove"

export const addRecycleMerchantCommission = "/zulin/pc/user/merchant/recycle/commission/create"

export const updateRecycleMerchantCommission = "/zulin/pc/user/merchant/recycle/commission/modify"

export const getContractTemplateList = "/zulin/pc/user/contract/tax/templates"

export const createContract = "/zulin/pc/user/contract/tax/create"

export const recycleSettledetaillist = "/zulin/pc/recycle/settle/detail/list"

export const getMerchantContractTemplateList = "/zulin/pc/user/contract/merchant/templates"

export const createMerchantContract = "/zulin/pc/user/contract/merchant/create"

export const saveContact2 = "/zulin/pc/user/phone/contact/save"

export const getMaterailTypeList = "/zulin/pc/credit/conf/material/types"

export const updateLiveAddress = "/zulin/pc/user/credit/order/liveAddress/update"

export const updateIdAddress = "/zulin/pc/user/credit/order/idAddress/update"

export const updateUserOtherAuth = "/zulin/pc/user/auth/record"

export const updateCompanyAddr = "/zulin/pc/user/credit/order/companyAddress/update"
